<template>
    <div class="artist-container">
        <img src="http://www.artgogo.com/online-exhibition/amicitia/original-img/artist-icon.jpg"/>
        <div class="artist-description">
            <h1>Peter Riezebos</h1>
            <div class="des" v-if="!isEnglish">
                <p>1980年出生的荷兰艺术家，创作风格主要是抽象和新表现主义。</p>
                <p>他自学成才，绘画时往往自由发挥，这种创造力源于他表达情感的强烈欲望，并从其幼小保持至今。他是畅销书《Van mavo tot Harvard》的作者，记叙了他从学校辍学到成为品学兼优和专业艺术家的人生故事。他学习心理学、传播学、企业管理学以及哲学。</p>
                <p>Peter年幼时患过社交障碍的疾病，而绘画成为了他抵抗疾病的最佳疗法。大约在22岁的时候，他受到身边朋友和亲人的鼓励重新开始画画，从自闭的阴影里走出来的他转而成为了艺术家，并撰写了书籍，在世界各地做演讲，激励人们用艺术的方法战胜心理疾病。Peter努力在创作中让自己变得更加自我，更加纯粹，不害怕做尝试，而是真正得释放自我。</p>
                <p>Peter的作品是色彩的爆发、抽象图形与风格的融合，它既有抽象表现主义绘画大师杰克逊·波洛克的画风，又如毕加索的抽象画作一般不羁。能看到他的作品中充满了重复出现的标志性符号，使用各种几何图形来塑造各种人物和形象，不少作品都是从中国传统人物形象中汲取了灵感。</p>
            </div>
            <div class="des" v-if="isEnglish">
                <p>Dutch artist Peter Riezebos (1980) creates drawings and paintings primarily in abstract, figurative, and neo-expressionism traditions. Peter Riezebos is an autodidact; his creative ability emerged early in life and originated from his neurological dispositions and strong desire to express his emotions and experiences visually. 
</p>
                <p>Peter Riezebos is the author of the autobiographical bestseller 'Van mavo tot Harvard', which tells his life story from school dropout and clinical debacle to excellent multidisciplinary student and professional artist. Peter considers himself a global citizen and paints on location all over the world (often residing the majority of the year in hotels all over Europe, Asia and the United States). His traveling and accompanied cross-cultural development is translated throughout his art, which are bold and powerful, emotionally attractive and his artistic ‘schwung’ demands immersive attention and interaction of the perceiver. Each painting is unique in its (color) composition and is constantly a combination of intentional creation – based on visualization – and free ad hoc expressionism. China, especially Shanghai, holds a special place in his heart, thus many works take inspiration from Chinese traditions. 
</p>
                
            </div>
            
        </div>
        <ChangeButton @change="changeLanguage"></ChangeButton>
    </div>
</template>
<style>
    .artist-container{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,0.85);
    }
    .artist-container img{
        width: 25%;
        position: absolute;
        left: 9%;
        top: 16%;
    }
    .artist-description{
        position: absolute;
        top: 5%;
        left: 40%;
        width: 50%;
        height: 80%;
        overflow: hidden;
    }
    .artist-description .des{
        height: 100%;
        width: 100%;
        overflow: auto;
    }
    .artist-description h1{
        color:white;
        font-size: 30px;
        text-align: left;
    }
    .artist-description p{
        color: white;
        font-size: 16px;
        text-align: left;
        line-height: 30px;
        margin-top: 10px;
    }
</style>
<script>
import ChangeButton from './ChangeButton.vue'

export default {
    components: {
        ChangeButton
    },
    data(){
        return{
            isEnglish: false
        }
    },
    methods:{
        changeLanguage(para){
            if(para == 'english'){
                this.isEnglish = true
            }else{
                this.isEnglish = false
            }
        }
    }   
}
</script>
